import megatron, {get} from '@ibibo/megatron';

const getRechargeStatus = async ({url, name}) => {
  return await megatron({
    name,
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getMyTripsHotelData = async ({url}) => {
  return await megatron({
    name: 'my trips hotel details api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getMyTripsModifyData = async ({url}) => {
  return await megatron({
    name: 'my trips modify details api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getWalletData = async ({url}) => {
  return await megatron({
    name: 'my trips data api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getMyTripsData = async ({url}) => {
  return await megatron({
    name: 'my trips data api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getMyTripsDetailsData = async ({url}) => {
  return await megatron({
    name: 'my trips details data api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getCancellationData = async ({url}) => {
  return await megatron({
    name: 'cancellation data api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getCancellationRefundData = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'refund breakup api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const getConfirmCancellation = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'refund breakup api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const addWalletBalance = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'refund breakup api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const confirmReschedule = async ({url, data}) => {
  // let fd = new FormData();
  // for (const key in data) {
  //   fd.append(key, data[key]);
  // }
  return await megatron({
    name: 'confirm reschedule api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: JSON.stringify(data),
  });
};

const updateUserSetting = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'user setting api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const updateUserName = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'name change api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const updateAadharNo = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'aadhar update api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const getNeftDetails = async ({url}) => {
  return await megatron({
    name: 'neft details api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const updateEmail = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'email id verify',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const unlinkMobile = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'mobile unlink  api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const unMask = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'mask remove api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};
const mask = async ({url}) => {
  return await megatron({
    name: 'mask  api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const updateMobile = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'mobile update api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const updateName = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'name update api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const getLoyaltyDetails = async ({url}) => {
  return await megatron({
    name: 'neft details api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const sendAgreement = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'send agreement acceptance',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const getEmailVerify = async ({url}) => {
  return await megatron({
    name: 'send otp to email',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getVerifiedEmailUpdate = async ({url}) => {
  return await megatron({
    name: 'send otp to email',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const updateEmailOtp = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'email update api',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const getRefundRaiseRequestListing = async ({url}) => {
  return await megatron({
    name: 'neft details api',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const sendRefundRaiseRequest = async ({url, data}) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return await megatron({
    name: 'send refund raise request',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const postUpdateTdsSlab = async ({url}) => {
  return await megatron({
    name: 'send refund raise request',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: {},
  });
};

const getGstInvoiceData = async ({url, data}) => {
  let fd = new FormData();

  for (const key in data) {
    fd.append(key, data[key]);
  }

  return await megatron({
    name: 'send refund raise request',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};

const getGstPdf = async ({url}) => {
  return await megatron({
    name: 'donwload the pdf for gst',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const getRequest = async ({url}) => {
  return await megatron({
    name: 'General get request',
    type: 'GET',
    url,
    credentials: 'include',
  });
};

const postRequest = async ({url, data}) => {
  let fd = new FormData();

  for (const key in data) {
    fd.append(key, data[key]);
  }

  return await megatron({
    name: 'send refund raise request',
    type: 'POST',
    url,
    credentials: 'include',
    requestData: fd,
  });
};
const submitLicenseDetailsCall = async ({url, data}) => {
  return await megatron({
    name: 'submit license details',
    url: url,
    type: 'POST',
    credentials: 'include',
    requestData: data,
  });
};

export {
  getRechargeStatus,
  getWalletData,
  getMyTripsData,
  getMyTripsDetailsData,
  getCancellationData,
  getCancellationRefundData,
  getConfirmCancellation,
  addWalletBalance,
  getMyTripsHotelData,
  getMyTripsModifyData,
  confirmReschedule,
  updateUserSetting,
  updateUserName,
  updateAadharNo,
  getNeftDetails,
  updateName,
  updateEmail,
  unlinkMobile,
  updateMobile,
  getLoyaltyDetails,
  sendAgreement,
  getEmailVerify,
  getVerifiedEmailUpdate,
  updateEmailOtp,
  getRefundRaiseRequestListing,
  sendRefundRaiseRequest,
  postUpdateTdsSlab,
  getGstInvoiceData,
  getGstPdf,
  getRequest,
  postRequest,
  submitLicenseDetailsCall,
  unMask,
  mask,
};
